import React, { useEffect } from "react";
import { AmountFormat } from "components/common/formatter";
import { useMatterBalances } from "services/matterBalancesService";

const EMPTY_BALANCES = { matterBalances: {}, clientBalances: {} };

const COLUMNS = [
  { label: "Office Bal", key: "officeBalance" },
  { label: "Client Bal", key: "clientBalance" },
  { label: "DDA Bal", key: "ddaBalance" },
  { label: "Unpaid Bills", key: "unpaidBills" },
  { label: "DUU", key: "duuBalance" },
  { label: "DPU", key: "dpuBalance" },
  { label: "DUB", key: "dubBalance" },
  { label: "WIP", key: "wipBalance" },
  { label: "U/T", key: "undertakingBalance" },
];

const LABEL_COLOR = "#707070";
const VALUE_COLOR = "#262626";
const ROW_BORDER = "0.5px solid rgba(171, 167, 167, 0.5)";

const isUndertakingAlert = (key, value) =>
  key === "undertakingBalance" && !!value && Number(value) !== 0;

const MatterAccount = (props) => {
  const { reloadToken } = props;
  const { data, refetch } = useMatterBalances(
    props.clear ? null : props.matterId,
  );
  const currentmattersBal = props.clear ? EMPTY_BALANCES : data ?? EMPTY_BALANCES;

  useEffect(() => {
    if (!props.matterId || !reloadToken) return;
    refetch();
  }, [reloadToken]);

  const rows = [
    { label: "This Matter", values: currentmattersBal.matterBalances },
    { label: "All Matters", values: currentmattersBal.clientBalances },
  ];

  return (
    <div
      className={`bg-white slim-scroll-x ${props.className ?? ""}`}
      style={{
        maxWidth: props.width,
        height: props.height,
        flex: "1 1 auto",
        minWidth: 0,
        padding: "8px 14px",
        borderRadius: "10px",
        boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.1)",
        overflowX: "auto",
      }}
    >
      <table
        className="w-100 fs-sm"
        style={{
          lineHeight: 1.3,
          minWidth: props.minWidth ?? "760px",
        }}
      >
        <thead>
          <tr>
            <th
              className="fw-normal text-nowrap"
              style={{
                fontSize: "0.8rem",
                color: LABEL_COLOR,
                padding: "0 0 4px",
                width: "1%",
              }}
            >
              Balances
            </th>
            {COLUMNS.map((c) => (
              <th
                key={c.key}
                className="fw-normal text-center text-nowrap"
                style={{
                  fontSize: "0.8rem",
                  color: LABEL_COLOR,
                  padding: "0 0 4px 12px",
                  width: `${99 / COLUMNS.length}%`,
                }}
              >
                {c.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.label}>
              <td
                className="text-nowrap"
                style={{
                  color: LABEL_COLOR,
                  padding: "3px 0",
                  borderTop: ROW_BORDER,
                }}
              >
                {r.label}
              </td>
              {COLUMNS.map((c) => {
                const amount = AmountFormat(r.values?.[c.key]);
                return (
                  <td
                    key={c.key}
                    className="text-end text-nowrap"
                    style={{
                      color: VALUE_COLOR,
                      fontWeight: 500,
                      padding: "3px 0 3px 12px",
                      borderTop: ROW_BORDER,
                    }}
                  >
                    {isUndertakingAlert(c.key, r.values?.[c.key]) ? (
                      <span
                        title="Outstanding undertaking"
                        style={{
                          background: "#fdecea",
                          color: "#c62828",
                          padding: "1px 6px",
                          borderRadius: "4px",
                        }}
                      >
                        {amount}
                      </span>
                    ) : (
                      amount
                    )}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default MatterAccount;
